function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  className: "opacity",
  opacity: 0.4,
  d: "M0 3.5576C0 1.5968 1.62418 0 3.6196 0H7.58845C9.5798 0 11.1999 1.592 11.1999 3.5496V12.4424C11.1999 14.404 9.57573 16 7.57949 16H3.61227C1.62011 16 0 14.408 0 12.4504V11.6984V3.5576Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  className: "white",
  d: "M15.8231 7.56389L13.5464 5.23669C13.3112 4.99669 12.9325 4.99669 12.698 5.23829C12.4642 5.47989 12.465 5.86949 12.6995 6.10949L13.9469 7.38389H12.751H6.03877C5.70764 7.38389 5.43884 7.65989 5.43884 7.99989C5.43884 8.34069 5.70764 8.61589 6.03877 8.61589H13.9469L12.6995 9.89029C12.465 10.1303 12.4642 10.5199 12.698 10.7615C12.8156 10.8823 12.9691 10.9431 13.1234 10.9431C13.2761 10.9431 13.4296 10.8823 13.5464 10.7631L15.8231 8.43669C15.936 8.32069 15.9999 8.16389 15.9999 7.99989C15.9999 7.83669 15.936 7.67989 15.8231 7.56389Z",
  fill: "white"
}));

function SvgLogoutIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.03ebb60f.svg";
export { ForwardRef as ReactComponent };